import { render } from "./DataQualityModuleProperties.vue?vue&type=template&id=4d147087&scoped=true"
import script from "./DataQualityModuleProperties.vue?vue&type=script&lang=js"
export * from "./DataQualityModuleProperties.vue?vue&type=script&lang=js"

import "./DataQualityModuleProperties.vue?vue&type=style&index=0&id=4d147087&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d147087"]])

export default __exports__